export enum RelanceOnboardingStatus {
    NotStarted = 'NotStarted',
    Completed = 'Completed',
    Refused = 'Refused',
}

export interface OnboardingStatusResponse {
    /** The company's decision, not this user's — one acceptance covers everyone. */
    status: RelanceOnboardingStatus;
    /** Raw Acomba relance access alone, independent of `status` — a user with no access here must
     * never see the onboarding walkthrough at all, regardless of their consent decision. */
    hasRelanceAccess: boolean;
    /** AcombaGO FlagResponsable / Acomba Supervisor. Fails closed: false until a host reports it. */
    isAdministrator: boolean;
    /** Per user, unlike `status` — a newcomer to a company that accepted long ago still gets it. */
    hasSeenWelcome: boolean;
}
